<template>
  <div class="warp">
    <!-- 头部工具栏 -->
    <div class="company_heard_tool">
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
    </div>
    <el-form ref="screenForm" :inline="true" :model="screenForm" class="demo-form-inline">
      <el-form-item label="昵称：" prop="nickName">
        <el-input v-model="screenForm.wechatNickName" />
      </el-form-item>
      <el-form-item label="授权手机号：" prop="wechatPhone">
        <el-input v-model="screenForm.wechatPhone" />
      </el-form-item>
      <el-form-item label="手机号：" prop="changePhone">
        <el-input v-model="screenForm.phone" />
      </el-form-item>
      <el-form-item label="人脸认证:" prop="isFace">
        <el-select v-model="screenForm.isFace" placeholder="不限" clearable>
          <el-option label="已认证" :value="true" />
          <el-option label="未认证" :value="false" />
        </el-select>
      </el-form-item>
      <el-form-item label="性别:" prop="gender">
        <el-select v-model="screenForm.sex" placeholder="不限" clearable>
          <el-option label="男" :value="0" />
          <el-option label="女" :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="screenForm.name" />
      </el-form-item>
      <el-form-item prop="memberStatus">
        <el-checkbox v-model="screenForm.memberStatus">已封号</el-checkbox>
      </el-form-item>
      <el-button type="primary" size="mini" icon="el-icon-search" style="margin-right: 10px" @click="screenData">筛选</el-button>
    </el-form>
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        ref="table"
        v-loading="loading"
        :max-height="tableH - 47"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        size="mini"
      >
        <el-table-column type="index" label="#" width="50" />
        <el-table-column label="微信授权资料" width="300">
          <template slot-scope="scope">
            <el-card style="background-color: #fafafa">
              <div style="display: flex; align-items: center">
                <el-image
                  :src="scope.row.wechatAvatarUrl"
                  style="width: 50px; height: 50px; border-radius: 8px; border: 1px dashed #c5c5c5"
                  @click="previewImage(scope.row.wechatAvatarUrl)"
                />
                <div style="flex: 1; display: flex; align-content: space-around; justify-content: center; flex-wrap: wrap; height: 50px">
                  <span>{{ scope.row.wechatNickName }}</span>
                  <div style="text-align: center; width: 100%">
                    {{ scope.row.wechatCity ? scope.row.wechatCity : '城市： 无' }}
                  </div>
                  <div>
                    <el-button type="primary" size="mini" icon="el-icon-view" @click="viewWXInfo(scope.row)">详情</el-button>
                  </div>
                </div>
              </div>
            </el-card>
          </template>
        </el-table-column>
        <el-table-column prop="wechatPhone" label="微信授权手机" width="110">
          <template slot-scope="scope">
            <div>
              {{ scope.row.wechatPhone || '-' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="头像">
          <template slot-scope="scope">
            <el-image :src="scope.row.avatar" style="width: 50px; height: 50px; border-radius: 8px" @click="previewImage(scope.row.avatar)" />
          </template>
        </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">
            {{ scope.row.name || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="性别">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.sex === 0" style="color: #1890ff">男</span>
              <span v-else-if="scope.row.sex === 1" style="color: #e94d4d">女</span>
              <span v-else>-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="birthday" label="出生年月">
          <template slot-scope="scope">
            <span v-if="scope.row.birthday">{{ scope.row.birthday | formatYM }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="人脸认证">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.isFace" style="color: #67c23a">已认证</span>
              <span v-else style="color: #f56c6c">未认证</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="110">
          <template slot-scope="scope">
            {{ scope.row.phone || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="创建时间" width="110">
          <template slot-scope="scope">
            {{ scope.row.createDate || '' }}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.memberStatus === '已封号'" style="color: #f56c6c">已封号</span>
              <span v-else style="color: #67c23a">正常</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button type="success" size="mini" icon="el-icon-view" style="margin: 6px 0 0" @click="viewResume(scope.row)">简历</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!--编辑状态 -->
    <el-dialog :close-on-click-modal="false" title="编辑" width="800px" :visible.sync="showEditDialog" append-to-body>
      <el-form ref="form" :model="form" label-position="right" label-width="100px" :rules="rules">
        <el-form-item prop="memberStatus" label="状态：">
          <div style="width: 100%; height: 28px; display: flex; align-items: center">
            <el-radio-group v-model="form.memberStatus">
              <el-radio label="正常">正常</el-radio>
              <el-radio label="已封号">已封号</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </div>
    </el-dialog>
    <!--图片放大对话款 -->
    <el-dialog :visible.sync="previewImageDialog">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <!--微信信息对话款 -->
    <el-dialog :visible.sync="showWXInfoDialog" title="微信授权资料" width="600px">
      <div class="wx-info-dialog">
        <el-form label-position="right" label-width="100px">
          <el-form-item label="头像：">
            <el-image
              v-if="currentRow"
              :src="currentRow.wechatAvatarUrl"
              style="width: 70px; height: 70px; border-radius: 8px"
              @click="previewImage(scope.row.avator)"
            />
          </el-form-item>
          <el-form-item label="openid：">
            <div v-if="currentRow">
              {{ currentRow.openid || '-' }}
            </div>
          </el-form-item>
          <el-form-item label="unionid：">
            <div v-if="currentRow">
              {{ currentRow.unionid || '-' }}
            </div>
          </el-form-item>
          <el-form-item label="昵称：">
            <div v-if="currentRow">
              {{ currentRow.wechatNickName || '-' }}
            </div>
          </el-form-item>
          <el-form-item label="语言：">
            <div v-if="currentRow">
              {{ currentRow.wechatLang || '-' }}
            </div>
          </el-form-item>
          <el-form-item label="城市：">
            <div v-if="currentRow">
              {{ currentRow.wechatCity || '-' }}
            </div>
          </el-form-item>
          <el-form-item label="性别：">
            <div v-if="currentRow">
              <!-- {{ currentRow.wechatGender  ? ['男', '女'][currentRow.wechatGender] : '-' }} -->
              <span v-if="currentRow.wechatGender === 0">男</span>
              <span v-else-if="currentRow.wechatGender === 1">女</span>
              <span v-else>-</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!--简历对话款 -->
    <el-dialog :visible.sync="showResumeDialog" title="用户简历" width="800px">
      <div class="wx-info-dialog" style="position: relative">
        <div v-if="!resumeForm" class="loading">
          <div class="el-icon-loading flex-center" style="width: 40px; height: 40px; font-size: 40px; color: #146bb3" />
        </div>
        <el-form v-else label-position="right" label-width="100px">
          <el-form-item label="求职状态：">
            {{ resumeForm.applyJobStatus }}
          </el-form-item>
          <el-form-item label="求职类型：">
            {{ resumeForm.applyJobType }}
          </el-form-item>
          <el-form-item label="期望职位：">
            {{ resumeForm.jobTitleName }}
          </el-form-item>
          <el-form-item label="薪资要求：">
            {{ resumeForm.salaryRange }}
          </el-form-item>
          <el-card>
            <div slot="header" class="clearfix">
              <span>附件简历</span>
            </div>
            <div v-for="(item, index) in resumeForm.resumeAttachmentVos" :key="index" style="line-height: 50px">
              <span style="margin-right: 30px">{{ item.fileName }}</span>
              <el-button type="success" icon="el-icon-view" @click="previewFile(item.fileUrl)">查看</el-button>
            </div>
          </el-card>
          <el-card style="margin-top: 30px">
            <div slot="header" class="clearfix">
              <span>工作经历</span>
            </div>
            <el-form
              v-for="(item, index) in resumeForm.workExpVos"
              :key="index"
              class="exprience"
              label-position="right"
              label-width="100px"
              style="border: 1px dashed #4aa0da; padding-top: 15px"
            >
              <el-form-item label="公司名称：">
                {{ item.companyName }}
              </el-form-item>
              <el-form-item label="职位名称：">
                {{ item.jobName }}
              </el-form-item>
              <el-form-item label="入职时间："> {{ item.startDate }} - {{ item.endDate }} </el-form-item>
              <el-form-item label="薪资：">
                {{ item.salary }}
              </el-form-item>
              <el-form-item label="工作描述：">
                {{ item.jobDescription }}
              </el-form-item>
            </el-form>
          </el-card>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pagination from '@/mixins/pagination'
export default {
  mixins: [pagination],
  data() {
    return {
      showWXInfoDialog: false,
      currentRow: null,
      currentResume: null,
      showEditDialog: false,
      showResumeDialog: false,
      resumeForm: null,
      tableData: [],
      loading: true,
      showDialog: false,
      dialogTitle: '',
      form: {
        memberStatus: null
      },
      rules: {
        memberStatus: { required: true, message: '请先用户账号状态', trigger: 'change' }
      },
      screenForm: {
        wechatNickName: '',
        phone: '',
        changePhone: '',
        isFace: null,
        sex: null,
        memberStatus: null,
        name: ''
      },
      tableH: 0
    }
  },
  mounted() {
    this.getTableList()
    this.tableH = this.$refs.tableWrap.clientHeight
  },
  methods: {
    screenData() {
      this.page = {
        pageNumber: 1,
        pageSize: 20
      }
      const data = Object.assign({}, this.screenForm)
      if (data.memberStatus === true) {
        data.memberStatus = 'CANCEL'
      } else {
        delete data.memberStatus
      }
      Object.assign(this.page, data)
      this.getTableList()
    },
    openEditDialog(row) {
      console.log(row)
      this.$nextTick(() => {
        this.form.memberStatus = row.memberStatus
        this.form.id = row.id
        this.showEditDialog = true
      })
    },
    async updateMemberStatus() {
      const data = {}
      Object.assign(data, this.form)
      const { memberStatus } = data
      data.memberStatus = memberStatus === '正常' ? 'NORMAL' : 'CANCEL'
      try {
        this.loading = true
        const res = await this.$api.member.reqUpdateMemberStatus(data)
        this.$message.success(res)
        this.showEditDialog = false
        this.getTableList()
      } catch (error) {
        console.error(error)
        this.$message.error('更新失败')
      }
    },
    viewResume(row) {
      this.showResumeDialog = true
      this.$api.member
        .reqMemberResume({ id: row.id })
        .then((res) => {
          this.resumeForm = res
          console.log('resume', res)
        })
        .catch(() => {})
    },
    previewFile(url) {
      const arr = url.split('.')

      if (arr[arr.length - 1] === 'pdf' || arr[arr.length - 1] === 'PDF') return window.open(url)
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url))
    },
    viewWXInfo(row) {
      this.currentRow = row
      this.showWXInfoDialog = true
    },
    refresh() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      this.$refs.screenForm.resetFields()
      Promise.all([this.getTableList()])
        .then(() => {
          this.loading = false
        })
        .catch(() => {
          this.$message.error('请求出错')
        })
    },
    getTableList() {
      this.loading = true
      return this.$api.member
        .reqMemberList(this.page)
        .then((res) => {
          console.log(res);
          this.tableData = res.records
          this.total = res.total
          this.loading = false
        })
        .catch((e) => {})
    },
    handleSubmit() {
      if (!this.validateForm()) return
      this.updateMemberStatus()
    },
    resetForm() {
      this.$refs.form.resetFields()
    },
    validateForm() {
      let pass
      this.$refs.form.validate((res) => {
        pass = res
        console.log('pass', pass)
      })
      return pass
    }
  }
}
</script>
<style lang="scss" scoped>
.warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 84px);
  .flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .company_heard_tool {
    margin-bottom: 10px;
  }
  .wx-info {
    padding: 10px 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .text-cut {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
  }
  .exprience {
    margin-bottom: 30px;
  }
  .exprience:last-of-type {
    margin-bottom: 0;
  }
}
</style>
